<p-button
  [styleClass]="styleClass"
  [icon]="icon"
  [label]="label"
  [type]="type"
  [disabled]="disabled"
  [severity]="severity"
  [rounded]="rounded"
  (click)="buttonClicked.emit()"
></p-button>
